const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="o-container o-container--pad o-container--prose">
<div class="o-container__content o-rhythm o-rhythm--default o-rhythm--generous-headings">

<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Aliquam ultrices sagittis orci a scelerisque purus semper.</p>

<article class="c-card c-card--contained o-container__fill-pad">
  <div class="c-card__content">
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Neque vitae tempus quam pellentesque nec nam aliquam sem et. Proin gravida hendrerit lectus a.</p>
  </div>
</article>

</div>
</div>

`);
                this.echo(this.include(context, this.source, this.loadTemplate(`1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 15, 74), undefined, true, false, 15));
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
        [74, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/ground-nav/ground-nav.twig`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 15);

                this.blocks = new Map([
                    ['feature_one', [this, 'block_feature_one']],
                    ['feature_two', [this, 'block_feature_two']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/ground-nav/ground-nav.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_feature_one(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <div class="c-ground-nav__feature-inner o-rhythm o-rhythm--condensed">
      <div class="o-rhythm o-rhythm--compact">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 19, 70), new Map([[`tag_name`, `h2`], [`level`, 1], [`weight`, `light`], [`feature_one_title`, (context.has(`feature_one_title`) ? context.get(`feature_one_title`) : null)]]), false, false, 19));
                this.echo(`        <p>
          `);
                this.echo(this.env.getFilter('escape').traceableCallable(30, this.source)(...[this.env, (context.has(`feature_one_content`) ? context.get(`feature_one_content`) : null), `html`, null, true]));
                this.echo(`
        </p>
      </div>
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 33, 71), new Map([[`feature_count`, (context.has(`feature_count`) ? context.get(`feature_count`) : null)]]), false, false, 33));
                this.echo(`    </div>
  `);
            }

            block_feature_two(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <form class="c-ground-nav__feature-inner o-rhythm o-rhythm--condensed" action="#">
      <div class="o-rhythm o-rhythm--compact">
        `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 51, 72), new Map([[`tag_name`, `h2`], [`level`, 1], [`weight`, `light`], [`feature_two_title`, (context.has(`feature_two_title`) ? context.get(`feature_two_title`) : null)]]), false, false, 51));
                this.echo(`        <p>
          `);
                this.echo(this.env.getFilter('escape').traceableCallable(62, this.source)(...[this.env, (context.has(`feature_two_content`) ? context.get(`feature_two_content`) : null), `html`, null, true]));
                this.echo(`
        </p>
      </div>
      `);
                this.echo(this.include(context, this.source, this.loadTemplate(`1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 65, 73), undefined, false, false, 65));
                this.echo(`    </form>
  `);
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
        [70, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 19);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.env.getFilter('escape').traceableCallable(26, this.source)(...[this.env, (context.has(`feature_one_title`) ? context.get(`feature_one_title`) : null), `html`, null, true]));
                this.echo(`
          `);
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
        [71, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/button-group/button-group.twig`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 33);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/button-group/button-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                context.proxy[`button_class`] = ((((context.has(`feature_count`) ? context.get(`feature_count`) : null) > 1)) ? (`c-button--secondary`) : (null));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `See our work`], [`class`, (context.has(`button_class`) ? context.get(`button_class`) : null)]]), false, false, 36));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Get in touch`], [`class`, (context.has(`button_class`) ? context.get(`button_class`) : null)]]), false, false, 40));
                this.echo(`        `);
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
        [72, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/components/heading/heading.twig`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 51);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/components/heading/heading.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`            `);
                this.echo(this.env.getFilter('escape').traceableCallable(58, this.source)(...[this.env, (context.has(`feature_two_title`) ? context.get(`feature_two_title`) : null), `html`, null, true]));
                this.echo(`
          `);
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
        [73, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/input-group/input-group.twig`, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, 65);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/input-group/input-group.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/input/input.twig`, new Map([[`placeholder`, `Your Email`], [`type`, `email`]]), false, false, 67));
                this.echo(`          `);
                this.echo(this.include(context, this.source, `@cloudfour/components/button/button.twig`, new Map([[`label`, `Sign up`]]), false, false, 71));
                this.echo(`        `);
            }

            getTemplateName() {
                return `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937');

let template = env.loadTemplate('1c1f7de65d5b3cbe42f793881e4077683800c6870d3bc864a66b877cdddd6937');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/ground-nav/demo/ground-nav-demo.twig", args: context }
     );
     return rendered;;
};